<template>
    <div class="script-detail">
        <Loading v-if="!loading"/>
        <TalkDialog v-if="showTalk" @closeTalk="getChildData"/>
        <div class="detail-father-router" v-if="loading">
            <div class="detail-top">
                <h3 class="title">{{scriptDetailInfo&&scriptDetailInfo.title}}</h3>
                <p class="author">{{scriptDetailInfo&&scriptDetailInfo.writer_type==1?'编剧':'策划'}}：{{scriptDetailInfo&&scriptDetailInfo.writer_name}}</p>
                <p class="type">剧本类型：{{scriptDetailInfo&&scriptDetailInfo.one_cateid_name}}</p>
                <p class="tag">剧本分类：{{scriptDetailInfo&&scriptDetailInfo.two_cateid_name.join('、')}}</p>
                <p class="end-status">完结状态：{{scriptDetailInfo&&scriptDetailInfo.over.name}}</p>
                <!-- <div class="script-set-num">
                    <span class="title">剧本集数</span>
                    <span class="num" v-if="scriptType==2"><span class="finish-num">{{scriptDetailInfo&&scriptDetailInfo.finish_set_num}}/</span><span class="total-num">{{scriptDetailInfo&&scriptDetailInfo.all_set_num}}集</span></span>
                </div>
                <ul class="tv-menu-list-box" v-if="scriptType==2">
                    <li class="menu-btn" v-for="(item,index) in menuList" :key="index" @click="toTvContentPage(item.lock,item.article_id,item.set_no)">
                        <span :style="item&&item.lock!==0?'color:#999':'color:#222'">试读{{index+1}}</span>
                        <img src="../../src/assets/img/menu-icon1.png" alt="" v-if="item.lock!==0">
                        <img src="../../src/assets/img/menu-icon2.png" alt="" v-if="item.lock==0">
                    </li>
                </ul>
				<div @click="toFilmContent" class="menu-btn" v-if="scriptType==1">
                    <span :style="filmNumLimit==1?'color:#222':'color:#999'">试读1</span>
                    <img src="../../src/assets/img/menu-icon1.png" alt="" v-if="filmNumLimit==0">
                    <img src="../../src/assets/img/menu-icon2.png" alt="" v-if="filmNumLimit==1">
                </div> -->
                <div class="end-logo" v-if="scriptDetailInfo&&scriptDetailInfo.over.value==1">{{scriptDetailInfo&&scriptDetailInfo.over.name}}</div>
                <div class="continue-logo" v-if="scriptDetailInfo&&scriptDetailInfo.over.value==0">{{scriptDetailInfo&&scriptDetailInfo.over.name}}</div>
            </div>
            <div class="main-intro">
                <div class="intro-detail" v-if="scriptDetailInfo&&scriptDetailInfo.yijuhua">
                    <h3>一句话故事</h3>
                    <p class="one-sentence">{{scriptDetailInfo&&scriptDetailInfo.yijuhua}}</p>
                </div>
                <div class="intro-detail" v-if="scriptDetailInfo&&scriptDetailInfo.purpose">
                    <h3>剧本立意</h3>
                    <v-clamp :max-lines="6" class="info-item">{{scriptDetailInfo&&scriptDetailInfo.purpose}}
                        <button class="toggle-btn" v-if="expanded || clamped" slot="after" slot-scope="{ toggle, expanded, clamped }" @click="toggle">{{clamped?'查看全部  ∨':'收起全部  ∧'}}</button>
                    </v-clamp>
                </div>
                <div class="intro-detail" v-if="scriptDetailInfo&&scriptDetailInfo.intro">
                    <h3>剧本梗概</h3>
                    <v-clamp :max-lines="6"  class="info-item">{{scriptDetailInfo&&scriptDetailInfo.intro}}
                        <button class="toggle-btn" v-if="expanded || clamped" slot="after" slot-scope="{ toggle, expanded, clamped }" @click="toggle">{{clamped?'查看全部  ∨':'收起全部  ∧'}}</button>
                    </v-clamp>
                </div>
                <div class="intro-detail" v-if="scriptDetailInfo&&scriptDetailInfo.personage">
                    <h3>人物阐述</h3>
                    <v-clamp :max-lines="6"  class="info-item">{{scriptDetailInfo&&scriptDetailInfo.personage}}
                        <button class="toggle-btn" v-if="expanded || clamped" slot="after" slot-scope="{ toggle, expanded, clamped }" @click="toggle">{{clamped?'查看全部  ∨':'收起全部  ∧'}}</button>
                    </v-clamp>
                </div>
            </div>
            <div class="comment-box">
                <div class="intro-detail" v-if="scriptDetailInfo&&scriptDetailInfo.zhuanyepinglun">
                    <h3>迷影人说</h3>
                    <v-clamp :max-lines="6"  class="info-item">{{scriptDetailInfo&&scriptDetailInfo.zhuanyepinglun}}
                        <button class="toggle-btn" v-if="expanded || clamped" slot="after" slot-scope="{ toggle, expanded, clamped }" @click="toggle">{{clamped?'查看全部  ∨':'收起全部  ∧'}}</button>
                    </v-clamp>                
				</div>
				<div class="assess-wrap" v-if="noScore">
					<FilmScore v-if="scriptType==1"/>
					<TvScore v-if="scriptType==2"/>
				</div>
            </div>
            <ul class="relate-rec" v-if="guessFavor.length">
                <h3>相关推荐</h3>
                <router-link v-for="(item,index) in guessFavor" :key="index" :to="{name:'scriptdetail',query:{id:item&&item.id,type:item&&item.type}}" tag="div" class="script-content">
                    <li class="script-list-box">
                        <div class="img-box">
                            <img :src="item&&item.image" alt="">
                            <span>{{item&&item.over===1?'已完结':'未完结'}}</span>
                        </div>
                        <div class="detail-box">
                            <p class="title">{{item&&item.title}}</p>
                            <p class="intro">{{item&&item.intro}}</p>
                            <p class="author-type"><span class="author">编剧：{{item&&item.user_name}}</span><span class="type">{{item&&item.one_cateid_name}}·{{item&&item.two_cateid_name.split(',').join('·')}}</span></p>
                        </div>
                    </li>
                </router-link>
            </ul>
            <div class="apply-form-box">
                <div class="follow-box">
					<div :class="{'follow-btn':true,'dfollow-btn':followStyle}" @click="toggleFollow($event)">
						<!-- <span class="unfollow"></span>
						<span class="follow"></span> -->
					</div>
				</div>
                <span class="to-form" @click="showTalkDialog">商务洽谈</span>
                <!-- <router-link :to="{name:'exchangecode',query:{id:this.$route.query.id}}" class="to-form" v-if="cdkeyStatus==0&&!vipStatus">查阅全部剧本</router-link> -->
                <router-link :to="{name:'askformore',query:{id:this.$route.query.id}}" class="to-form" v-if="applyFormStatus==0&&!vipStatus">申请试读</router-link>
                <span class="to-form" @click="toContentPage">查看试读</span>
            </div>
        </div>
    </div>
</template> 
<script>
import Loading from '@/components/Loading.vue'
import TalkDialog from '@/components/TalkDialog.vue'
import FilmScore from '@/components/FilmScore.vue'
import TvScore from '@/components/TvScore.vue'
import {Axios} from '@/assets/api/axios'
import axios from 'axios'
import VClamp from 'vue-clamp'
import {GetCookie} from '@/assets/api/cookie'
import notifyIcon from '@/assets/img/msgicon.png'
export default {
	name:'ScriptDetail',
	beforeRouteUpdate(to,from,next){
        Axios.get('/article/detail/'+to.query.id).then(
            response=>{
                if(response.data.code==200&&response.data.status=="success"){
					this.scriptDetailInfo=response.data.data
					this.scriptType=response.data.data.type.value
					this.followStyle=response.data.data.is_follow
					next()
                }
            }
        )
    },
    data(){
        return{
			scriptDetailInfo:'',           //剧本详情数据
			scriptType:'',                 //当前剧本类型  1是电影  2是电视剧
            guessFavor:'',                 //猜你喜欢数据
			loading:false,                 //控制加载画面显示隐藏   
			followStyle:'',                //关注按钮的样式状态
			date:new Date(),               //定义事件对象
			curTime:'',                    //每次进入页面获取实时的时间
            noScore:'',                    //判断是否有评分信息
            showTalk:false,                //控制商务洽谈弹窗显示隐藏
            menuList:[],                   //储存电视剧目录数据
			cdkeyStatus:'',                //控制查阅全部剧本和申请指定章节按钮显示隐藏
			applyFormStatus:'',            //申请指定章节按钮显示隐藏
            vipStatus:'',                  //判断是否是VIP
            filmDefaultLimit:'',           //电影默认试读权限设置
            tvDefaultLimit:'',             //电视剧默认试读权限设置
            filmSetLimit:'',               //电影提交表单后试读权限设置
            tvSetLimit:'',                 //电视剧提交表单后试读权限设置  
        }
    },
    created(){
        this.vipStatus=GetCookie('v')
        if(this.$route.query.type==2){
            Axios.get('/article/preview/'+this.$route.query.id).then(
                response=>{
                    if(response.data.code==200&&response.data.status=="success"){
                        this.menuList=response.data.data   
                    }
                }
            )
        }
		//是否有评分数据
		Axios.get('article/assess',{params:{type:this.$route.query.type,id:this.$route.query.id}}).then(
			response=>{
				if(response.data.code==200&&response.data.status=="success"){
					if(response.data.data.level==""){
						this.noScore=false
					}else{
						this.noScore=true
					}
				}
			},
			error=>{
				console.log(error)
			}
		)
		//获取实时时间请求接口
		this.curTime=this.date.getFullYear()+'-'
		this.curTime=this.curTime+(this.date.getMonth()+1)+'-'
		this.curTime=this.curTime+(this.date.getDate())+' '
		this.curTime=this.curTime+(this.date.getHours())+':'
		this.curTime=this.curTime+(this.date.getMinutes())+':'
		this.curTime=this.curTime+(this.date.getSeconds())
		if(GetCookie('token')){
			Axios.defaults.headers.common['Authorization']=GetCookie('token')
		}
        axios.all([
            Axios.get('/article/detail/'+this.$route.query.id),
            Axios.get('/article/guessat/'+this.$route.query.id),
        ])
        .then(
            axios.spread((detailResponse,guessFavorResponse)=>{
                this.getScriptDetail(detailResponse)
                this.getGuseeFavor(guessFavorResponse)
                this.loading=true               
            })
        )
    },
    watch:{
		//电影目录可点击权限判断
        'scriptDetailInfo':function(val){
            this.filmDefaultLimit=val.try_num_limit
            this.tvDefaultLimit=val.try_set_limit
            this.filmSetLimit=val.try_num_form_limit
            this.tvSetLimit=val.try_set_form_limit
			this.cdkeyStatus=val.cdkey
			if(val.cdkey!==0){
				this.applyFormStatus=1
			}else{
				this.applyFormStatus=val.apply_form
			}
		}
    },
    methods:{
        //查看试读跳转剧本内容页权限判断
        toContentPage(){
            if(!GetCookie('token')){
                this.$swal({
					text:'未登录不能进行此操作',
					showConfirmButton:false,
					width:'6rem',
					padding:'0.5rem',
					timer:1200,
					imageWidth:50,
					imageHeight:50,
					imageUrl:notifyIcon,
					timerProgressBar: true
				})
            }else{
                if(this.cdkeyStatus){
                    this.$router.push({name:'contentpage',query:{id:this.$route.query.id,set:1,type:this.scriptType}})
                }else if(this.scriptType==1&&this.filmDefaultLimit){
                    this.$router.push({name:'contentpage',query:{id:this.$route.query.id,set:1,type:this.scriptType}})
                }else if(this.scriptType==2&&this.tvDefaultLimit){
                    this.$router.push({name:'contentpage',query:{id:this.$route.query.id,set:1,type:this.scriptType}})
                }else if(this.applyFormStatus&&this.scriptType==1&&this.filmSetLimit){
                    this.$router.push({name:'contentpage',query:{id:this.$route.query.id,set:1,type:this.scriptType}})
                }else if(this.applyFormStatus&&this.scriptType==2&&this.tvSetLimit){
                    this.$router.push({name:'contentpage',query:{id:this.$route.query.id,set:1,type:this.scriptType}})
                }else{
                    this.$swal({
                        text:'无试读权限',
                        showConfirmButton:false,
                        width:'6rem',
                        padding:'0.5rem',
                        timer:1200,
                        imageWidth:50,
                        imageHeight:50,
                        imageUrl:notifyIcon,
                        timerProgressBar: true
                    })
                }
            }
            // if(lock!==0){
            //     this.$swal({
			// 		text:'填写申请指定章节表单可查看更多剧集',
			// 		showConfirmButton:false,
			// 		width:'6rem',
			// 		padding:'0.5rem',
			// 		timer:1200,
			// 		imageWidth:50,
			// 		imageHeight:50,
			// 		imageUrl:notifyIcon,
			// 		timerProgressBar: true
			// 	});
            // }else if(lock==0){
            //     this.$router.push({name:'contentpage',query:{id:id,set:set,type:this.scriptType}})
            // }
        },
        //显示商务洽谈弹窗
        showTalkDialog(){
            this.showTalk=true
        },
        getChildData(data){
            this.showTalk=data
        },
        //处理剧本详情数据
        getScriptDetail(detailResponse){
            if(detailResponse.data.code==200&&detailResponse.data.status=="success"){
				this.scriptDetailInfo=detailResponse.data.data
				this.scriptType=detailResponse.data.data.type.value
				this.followStyle=detailResponse.data.data.is_follow
            }
        },
        //获取相关作品
        getGuseeFavor(guessFavorResponse){
            if(guessFavorResponse.data.code==200&&guessFavorResponse.data.status=="success"){
                this.guessFavor=guessFavorResponse.data.data
            }
        },
        getFollowStatus(isFollowResponse){
            if(isFollowResponse.status==200){
                this.isFollow=isFollowResponse.data
            }
		},
		//切换剧本关注状态
		toggleFollow(e){
            if(e.currentTarget.classList.contains('dfollow-btn')){
                Axios.get('/article/unfollow/'+this.$route.query.id).then(
                    response=>{
                        if(response.data.code==200&&response.data.status=="success"){
                            this.followStyle=0
                        }
                    }
                ).catch(
					error=>{
						if(error.response.data.code==422){
							this.$swal({
								text:'未登录或登录超时 请重新登录',
								showConfirmButton:false,
								width:'6rem',
								padding:'0.5rem',
								timer:1000,
								imageWidth:50,
								imageHeight:50,
								imageUrl:notifyIcon,
								timerProgressBar: true
							})
							setTimeout(()=>{
								location.href='/login'
							},1000)
						}
					}
				)
            }else{
                Axios.get('/article/follow/'+this.$route.query.id).then(
                    response=>{
                        if(response.data.code==200&&response.data.status=="success"){
                            this.followStyle=1
                        }
                    }
                ).catch(
					error=>{
						if(error.response.data.code==422){
							this.$swal({
								text:'未登录或登录超时 请重新登录',
								showConfirmButton:false,
								width:'6rem',
								padding:'0.5rem',
								timer:1000,
								imageWidth:50,
								imageHeight:50,
								imageUrl:notifyIcon,
								timerProgressBar: true
							})
							setTimeout(()=>{
								location.href='/login'
							},1000)
						}
					}
				)
            }
        }
    },
    components:{
		VClamp,
		FilmScore,
		TvScore,
        Loading,
        TalkDialog
    }
}
</script>

<style scoped lang="scss">
    .script-detail{
        position:relative;
        width:750px;
        padding-top:88px;
        .detail-top{
            width:664px;
            padding:60px 0 40px 0;
            border-bottom:1px solid #E6E6E6;
            margin:0 auto;
            .title{
                font-size:34px;
                color:#222;
                height:32px;
                margin-bottom:20px;
                font-weight:bold;
            }
            .author{
                color:#535353;
                font-size:24px;
                font-weight:500;
                margin-bottom:40px;
            }
            .type,.tag,.end-status{
                margin-bottom:18px;
                font-size:20px;
                color:#999;
            }
            .end-status{
                margin-bottom:26px;
            }
            .menu-btn{
                width:120px;
                height:50px;
                border-bottom:1px solid #e6e6e6;
                line-height:50px;
                color:#282828;
                font-size:24px;
                img{
                    width:20px;
                    height:20px;
                    margin-left:34px;
                }
            }
            .tv-menu-list-box{
                display:flex;
                display:-webkit-flex;
                li{
                    margin-right:30px;
                }
            }
            .end-logo{
                position:absolute;
                top:148px;
                right:40px;
                width:80px;
                height:70px;
                background:url('../assets/img/statuslogr.png') no-repeat;
                background-size:cover;
                text-align:center;
                color:#fff;
                font-size:18px;
                line-height:50px;
                font-weight:bold;
            }
            .continue-logo{
                position:absolute;
                top:148px;
                right:40px;
                width:80px;
                height:70px;
                background:url('../assets/img/statuslogb.png') no-repeat;
                background-size:cover;
                text-align:center;
                color:#fff;
                font-size:18px;
                line-height:50px;
                font-weight:bold;
            }
            .script-set-num{
                margin-bottom:30px;
                overflow:hidden;
                .title{
                    font-size:30px;
                    font-weight:bold;
                    color:#222;
                }
                .num{
                    float:right;
                    letter-spacing:3px;
                    .finish-num{
                        font-weight:bold;
                        font-size:26px;
                    }
                    .total-num{
                        color:#999;
                    }
                }
            }
        }
        /deep/.intro-detail{
            width:664px;
            padding:60px 0 68px 0;
            border-bottom:1px solid #E6E6E6;
            margin:0 auto;
            position:relative;
            .toggle-btn{
                background:#fff;
                height:30px;
                border:none;
                position:absolute;
                left:0;
                bottom:30px;
                font-size:22px;
                color:#999;
                padding-left:0;
            }
            span{
                white-space: pre-line !important;
            }
            h3{
                font-size:30px;
                font-weight:bold;
                color:#222;
                margin-bottom:30px;
            }
            .one-sentence{
                font-size:24px;
                color:#999;
                line-height:36px;
                text-align:left;
            }
            .info-item{
                color:#999;
                text-align:left;
                margin-bottom:20px;
                font-size:24px;
                line-height:38px;
				overflow:visible !important;
            }
        }
        .line{
            height:10px;
            background:#f7f7f7;
        }
        .comment-box{
            width:664px;
            margin:0 auto;
			.assess-wrap{
				width:100%;
				height:800px;
				margin-top:30px;
				margin-bottom:20px;
			}
        }
        .relate-rec{
            width:664px;
            margin:0 auto;
            h3{
                font-size:30px;
                color:#222;
                padding:40px 0 30px 0;
                font-weight:bold;
            }
            .script-list-box{
                background:#fff;
                margin-bottom:10px;
            }
            .script-list-box:last-child{
                border-bottom:none;
                height:340px;
            }
            .script-content{
                height:175px;
                padding:38px 0;
                border-bottom:1px solid #E6E6E6;
                .img-box,.detail-box{
                    float:left;
                }
                .img-box{
                    width:122px;
                    height:175px;
                    margin-right:26px;;
                    position:relative;
                    img{
                        width:100%;
                    }
                    span{
                        display:inline-block;
                        width:80px;
                        height:26px;
                        font-size:18px;
                        line-height:26px;
                        text-align:center;
                        position:absolute;
                        left:0;
                        bottom:20px;
                        color:#fff;
                        background:rgba(0,0,0,.5);
                        border-radius:0 35px 35px 0;
                    }
                }
                .detail-box{
                    width:512px;
                    .title{
                        height:30px;
                        font-size:30px;
                        color:#333;
                        font-weight:bold;
                        margin-bottom:15px;
                    }
                    .intro{
                        height:68px;
                        color:#222;
                        text-align:left;
                        margin-bottom:38px;
                        color:#222;
                        font-size:24px;
                        line-height:38px;
                        display: -webkit-box;
                        line-height: 1.4;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                    .author-type{
                        height:24px;
                        font-size:24px;
                        color:#999;
                        .type{
                            float:right;
                        }
                    }
                }
                
            }
        }
        .apply-form-box{
            width:690px;
            padding:22px 30px 22px 30px;
            background:#FFFEFF;
            position:fixed;
            bottom:0;
            left:0;
            overflow:hidden;
            box-shadow:0px -1px 4px #F5F5F5;
			.follow-box{
				width:40px;
				height:36px;
				overflow:hidden;
				position:absolute;
				left:50px;
				top:50%;
				margin-top:-18px;
				.dfollow-btn{
					background:url('../assets/img/follow.png') no-repeat !important;
					background-size:100% 100% !important;
				}
				.follow-btn{
					width:40px;
					height:36px;
					background:url('../assets/img/unfollow.png') no-repeat;
					background-size:100% 100%;
				}
			}
            .to-form{
                font-size:20px;
                color:#222;
                padding:26px 16px;
                background:#EDEAEB;
                display:inline-block;
                margin-right:20px;
                float:right;
            }
            .to-form:active{
                background:#ccc;
            }
        }
    }
</style>